import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';
import { isBlueberryFeature } from '../../../services/data/impl/cube/cubeUtils';
import { selectCurrFeature } from '../../select/selectSlice';

/**
 * Checks whether the given feature is related to blueberries.
 *
 * @returns True if the feature is related to blueberries; false otherwise.
 */
const useIsBlueberryFeature = () => {
  const currFeature = useAppSelector(selectCurrFeature);

  return useMemo(() => {
    return isBlueberryFeature(currFeature);
  }, [currFeature]);
};

export default useIsBlueberryFeature;
